import { render, staticRenderFns } from "./PlainBtn.vue?vue&type=template&id=064916df&scoped=true&"
import script from "./PlainBtn.vue?vue&type=script&lang=js&"
export * from "./PlainBtn.vue?vue&type=script&lang=js&"
import style0 from "./PlainBtn.vue?vue&type=style&index=0&id=064916df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064916df",
  null
  
)

export default component.exports